// eslint-disable-next-line
export const CELL_SIZE = 32
